import { useEffect, useState, type MouseEvent } from 'react'
import { Link, useNavigate, type LinkProps } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useSession } from '@/lib/auth-client'
import { getLocalizedPath } from '@/i18n/routes'
import type { SupportedLanguage } from '@/i18n'

/**
 * Ingresso all'area riservata: la destinazione la decide la sessione (Better Auth, /api/auth/get-session).
 * Utente valido e abilitato → admin, altrimenti → login. Un click che arriva mentre la sessione è
 * ancora in verifica aspetta l'esito.
 */
export function ReservedAreaLink({ onClick, ...props }: Omit<LinkProps, 'to'>) {
  const { i18n } = useTranslation()
  const { data: session, isPending } = useSession()
  const navigate = useNavigate()
  const [isWaiting, setIsWaiting] = useState(false)
  const lang = i18n.language as SupportedLanguage
  const target = getLocalizedPath(session?.user.enabled ? 'admin' : 'login', lang)

  useEffect(() => {
    if (!isWaiting || isPending) return
    setIsWaiting(false)
    navigate(target)
  }, [isWaiting, isPending, navigate, target])

  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    onClick?.(event)
    if (!isPending) return
    event.preventDefault()
    setIsWaiting(true)
  }

  return <Link to={target} onClick={handleClick} {...props} />
}
